import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Alert from 'react-bootstrap/Alert'
import { Offcanvas } from 'react-bootstrap'
import { PanelFooter, PanelHeader } from 'components/Panel'
import { getFileData } from 'utils/general'

function VerPatente(props) {
	const { patente, setQueMostrar } = props

	const handleClose = () => {
		setQueMostrar('')
	}

	const solicitadasFileData = getFileData(patente.solicitadas?.url)
	const otorgadasFileData = getFileData(patente.otorgadas?.url)

	// render
	return (
		<Offcanvas show={true} onHide={handleClose} placement="end" scroll="true" responsive="lg">
			<PanelHeader onClick={handleClose} iconClass="fa-arrow-left" btnText="Atrás" text="Ver patente" />
			<Offcanvas.Body id="ver-patente">
				<h1>Campos de la patente</h1>
				<Row className="mb-3">
					<Col>
						<label>Año</label>
						<div className="patente-anho">
							{patente.anho}
						</div>
					</Col>
				</Row>
				<Row>
					<Col>
						<label>Solicitadas</label>
						<div>
							<i className={solicitadasFileData.icono}></i> <a href={process.env.REACT_APP_API_URL + 'uploads/' + patente.solicitadas?.url}>{solicitadasFileData.nombre}</a>
						</div>
					</Col>
				</Row>
				<Row>
					<Col>
						<label>Otorgadas</label>
						<div>
							<i className={otorgadasFileData.icono}></i> <a href={process.env.REACT_APP_API_URL + 'uploads/' + patente.otorgadas?.url}>{otorgadasFileData.nombre}</a>
						</div>
					</Col>
				</Row>
			</Offcanvas.Body >
		<PanelFooter>
			<Button variant="outline-primary" onClick={handleClose} className="me-2">
				Ok
			</Button>
		</PanelFooter>
		</Offcanvas >
	)
}

export default VerPatente